<template>
	<div id="app">
		<!-- <img src="./assets/logo.png"> -->
		<router-view />
	</div>
</template>

<script>
	import 'babel-polyfill'
	export default {
		name: 'App',
		mounted() {
			// if (this._isMobile()) {
			// 	// alert("手机端");
			// 	this.$router.replace('/mindex');
			// } else {
			// 	// alert("pc端");
			// 	this.$router.replace('/index');
			// }
		},
		methods: {
			_isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag;
			}
		}

	}
</script>

<style>
	body {
		margin: 0px;
	}

	#app {
		font-family:"microsoft yahei", Verdana, Arial, Tahoma!important;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	
		color: #2c3e50;
		min-width: 1200px;

	}
	/* SimHei, 'Avenir', Helvetica, Arial, */
</style>



// WEBPACK FOOTER //
// src/App.vue